import * as yup from 'yup';

export const taxServiceRegistrationSchema = yup.object({
  taxService: yup
    .string()
    .required("Le champ 'Service' est requis")
    .min(3, "Le champ 'Service' doit contenir au moins 3 caractères"),
  taxVille: yup
    .string()
    .required("Le champ 'Ville' est requis")
    .min(3, "Le champ 'Ville' doit contenir au moins 3 caractères"),
});